import request from '@/utils/request';

const path = 'api/v1';

const customersList = data => request({
  url: `${path}/customers`,
  method: 'Get',
  params: data,
});

const customersPost = (data) => request({
    url: `${path}/customers`,
    method: 'post',
    data
});

const customersDelete = (data) => request({
    url: `${path}/customers`,
    method: 'delete',
    params: data,
});

const customersPut = (data) => request({
    url: `${path}/customers`,
    method: 'put',
    data,
});

export {
  customersList,
  customersPost,
  customersDelete,
  customersPut
};
